<template>
  <ConfigErrorBoundary>
    <FileConverter
      :config="converterConfig"
      @batch-created="handleBatchCreated"
      @job-completed="handleJobCompleted"
      @batch-cleared="handleBatchCleared"
      @error="handleError"
      @credits-updated="handleCreditsUpdated"
    />
  </ConfigErrorBoundary>
</template>

<script setup lang="ts">
import FileConverter from './FileConverter.vue';
import ConfigErrorBoundary from './ConfigErrorBoundary.vue';
import { parseAndValidateConverterConfig } from '../utils/ConfigValidator';

// Parse and validate configuration using fail-fast Zod validation
const baseConfig = parseAndValidateConverterConfig('psd-to-png-converter', 'PSD → PNG');

// Merge base config with PSD→PNG specific labels
const converterConfig = {
  ...baseConfig,
  jobCategory: 'image.psd-to-png',
  labels: {
    dropzoneHeading: 'Drop PSD Files Here',
    emptyQueueMessage: 'Drop Photoshop files to start your first conversion.',
    statsLabel: 'Median PSD → PNG time (last 10k jobs): {p50TimeMs}',
    batchCompleteTitle: 'All {n} files converted successfully!',
    batchInProgressTitle: 'Converting {n} files...',
  },
  supportUrl: '/contact',
  pricingUrl: '/pricing',
};

// Event handlers
function handleBatchCreated(batchId: string) {
  console.log('[PSD to PNG Converter] Batch created:', batchId);
}

function handleJobCompleted(jobId: string) {
  console.log('[PSD to PNG Converter] Job completed:', jobId);
}

function handleBatchCleared() {
  console.log('[PSD to PNG Converter] Batch cleared');
}

function handleError(error: Error) {
  console.error('[PSD to PNG Converter] Error:', error);
}

function handleCreditsUpdated(credits: number) {
  console.log('[PSD to PNG Converter] Credits updated:', credits);
}
</script>
